"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditToolbar = EditToolbar;
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var changesMadeToUnderEditImageData_1 = require("../../utils/changesMadeToUnderEditImageData");
var themes_1 = require("../../../../../../themes");
var Buttons_1 = require("../../../../../Buttons");
/**
 * fiddle for dealing with rotation: https://jsfiddle.net/wunderbart/w1hw5kv1/
 */
function EditToolbar(_a) {
    var setUnderEditImageData = _a.setUnderEditImageData, underEditImageData = _a.underEditImageData, imageData = _a.imageData, handleSingleImageDataChange = _a.handleSingleImageDataChange, setImageUnderEdit = _a.setImageUnderEdit, //comes from ImageInput context if used inside it
    imageSpread = _a.imageSpread, publicUrl = _a.publicUrl, defaultImageSpread = _a.defaultImageSpread, omitEditorTools = _a.omitEditorTools;
    return (react_1.default.createElement("div", { style: {
            width: "100%",
            padding: "0.5rem",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: themes_1.colors.black_opacity80,
        } },
        react_1.default.createElement("div", { style: {
                display: "flex",
                gap: "0.5rem",
            } },
            !omitEditorTools.includes('cover_contain') &&
                react_1.default.createElement(Buttons_1.ButtonGhost, { invert: true, S: true, iconSize: "M", onClick: function () {
                        return setUnderEditImageData(function (prev) {
                            var spreadToSet = imageSpread === "cover" ? "contain" : "cover";
                            return __assign(__assign(__assign({}, prev), { imageSpread: spreadToSet }), (spreadToSet === "contain" ? { cropX: 0, cropY: 0 } : {}));
                        });
                    }, icon: imageSpread === "cover" ? "ArrowsIn" : "ArrowsOut" }),
            !omitEditorTools.includes('rotate') &&
                react_1.default.createElement(Buttons_1.ButtonGhost, { invert: true, icon: "ArrowsClockwise", iconSize: "M", S: true, onClick: function () {
                        setUnderEditImageData(function (prev) { return (__assign(__assign({}, prev), { imageRotate: ((prev.imageRotate || 0) + 90) % 360 })); });
                    } })),
        react_1.default.createElement("div", { style: {
                display: "flex",
                gap: "0.5rem",
            } },
            (0, changesMadeToUnderEditImageData_1.changesMadeToUnderEditImageData)({
                imageData: imageData,
                underEditImageData: underEditImageData,
                defaultImageSpread: defaultImageSpread,
            }) && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(Buttons_1.ButtonSecondary, { invert: true, S: true, onClick: function () {
                        setUnderEditImageData((0, lodash_1.cloneDeep)(imageData));
                    } }, "Revert"),
                react_1.default.createElement(Buttons_1.ButtonPrimary, { invert: true, S: true, onClick: function () {
                        handleSingleImageDataChange({
                            publicUrl: publicUrl,
                            imageData: __assign(__assign({}, underEditImageData), { caption: imageData.caption //cuz caption edits are made directly to imageData and we dont want underEditImageData to overwrite that.
                             }),
                        });
                        setUnderEditImageData(undefined);
                        setImageUnderEdit && setImageUnderEdit(false);
                    } }, "Save"))),
            react_1.default.createElement(Buttons_1.ButtonGhost, { invert: true, icon: "X", S: true, onClick: function () {
                    setUnderEditImageData(undefined);
                } }))));
}
